import React, { useCallback, useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import LayersIcon from "@mui/icons-material/Layers";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { Link, useLocation, useParams } from "react-router-dom";
import podetailImage from "../../assests/images/Po details.png";
import summaryImage from "../../assests/images/Summary.png";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import checkcircleImage from "../../assests/images/check-circle.png";
import rejectImage from "../../assests/images/Reject.png";
import { UserObj } from "../../services/localStarage";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepContent from "@mui/material/StepContent";
import Paper from "@mui/material/Paper";
import SupportChat from "../support/chat";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import Stack from "@mui/material/Stack";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import topArrow from '../../assests/images/top.png';
import topHighlightArrow from '../../assests/images/top-highlighted.png';
import bottomArrow from '../../assests/images/bottom.png';
import bottomHighlightArrow from '../../assests/images/bottom-highlighted.png';
import CachedOutlinedIcon from '@mui/icons-material/CachedOutlined';
import Accordion from "@mui/material/Accordion";
import AccordionActions from "@mui/material/AccordionActions";
import checkImage from "../../assests/images/check-circle.png";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { getSecPermission, isEmptyDash, strToDate,trimString, totalInr, returnRateVal } from "../../constant";
import Tooltip from '@mui/material/Tooltip';
import { gateEntryServices } from "../../services/gateEntryServices";
import _ from "lodash";
import AlertComponent from "../alert/alert";
import { Backdrop, CircularProgress } from "@mui/material";
import { downloadFile } from "../buyerPurchaseOrder";
import { purchaseOrderServices } from "../../services/purchaseOrderServices";
import TrackOrder from "../common/trackOrder";

const initialColumns = [
  { id: "productNumber", label: "Material No", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "description", label: "Description", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "poQty.", label: "Po Ouantity", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "unit", label: "Unit of Measure", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "storageLocation", label: "Storage Location", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "netPrice", label: "Net Price", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "RATE" },
  { id: "acceptQty", label: "Accept Quantity", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "totalQuantity", label: "Toatal Quantity", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "remainingQuantity", label: "Remaining Po Quantity", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "remarks", label: "Remarks", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
];

const style1 = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const permissionInit = {
  create: false,
  read: false,
  update: false,
  delete: false,
};

function GateEntryDetail() {
  const { id } = useParams();
  const [openmodifygateentry, setOpenModifyGateEntry] = useState(false);
  const [opencancelgateentry, setOpenCancelGateEntry] = useState(false);
  const [trackOrderData, setTrackOrderData] = useState("");
  const [GRNPurchaseOrderID, setGRNPurchaseOrderID] = useState("");
  const userRole = UserObj ? UserObj?.role?.name : "";
  const reducer = (state, action) => {
    switch (action.type) {
      case "TOGGLE_DRAWER":
        return { ...state, open: action.newOpen };
      default:
        throw new Error(`Unknown action: ${action.type}`);
    }
  };

  const [state, dispatch] = React.useReducer(reducer, { open: false });

  const requestPayloadInitials = {
    pageNumber: 1,
    pageSize: 10,
    sortArray: [],
    searchCriteria: [],
  };
  const [isLoading, setIsLoading] = useState(false);
  // const [selectedFile, setSelectedFile] = useState(null);
  const [requestPayload, setRequestPayload] = useState(requestPayloadInitials);
  const [filterText, setFilterText] = useState("");
  const [filterFormData, setFilterFormData] = useState("");
  const [columns, setColumns] = useState(initialColumns);

  const [isMediaListModalOpen, setIsMediaListModalOpen] = useState(false);
  const [uploadFilesObj, setUploadFilesObj] = useState({});

  const [downloadEl, setdownloadEl] = React.useState(null);
  const [confirmObj, setConfirmObj] = useState({});
  const [openpopdfpurchasemodal, setOpenPoPdfPurchaseModal] = useState(false);
  const [openpopdfpurchasesuccessmodal, setOpenPoPdfPurchaseSuccessModal] = useState(false);

  const [secGEPermission, setSecGEPermission] = useState({
    "GATE_ENTRY_LISTING": permissionInit,
    "GATE_ENTRY_DETAIL": permissionInit,
    "TRACK_ORDER_GE": permissionInit,
    "DOWNLOAD_GE": permissionInit,
  });

  const [geDetails, setGEDetails] = React.useState({});
  const [productsListing, setProductsListing] = React.useState({
    totalPages: 0,
    currentPage: 1,
    totalItems: 0,
    products: [],
  });

  const [inputPage, setInputPage] = useState(productsListing?.currentPage || 1);
  const [alertComponent, setAlertComponent] = useState({
    open: false,
    message: "",
    type: "",
  });

  useEffect(() => {
    getDetails(id);
    let secGEPermissionInit = _.cloneDeep(secGEPermission);
    let obj = {};
    for (let key in secGEPermissionInit) {
      obj[key] = getSecPermission(key);
    }
    setSecGEPermission(obj);
  }, []);

  const handleCloseAlert = (event, reason) => {
    setAlertComponent({ ...alertComponent, open: false });
  };

  const getDetails = (param) => {
    setIsLoading(true);
    let url = `/${param}`;
    let promise = gateEntryServices.getGEListing(url);
    promise.then((res) => {
      if (res.data.success === true) {
        setGEDetails(res.data?.data);
        setGRNPurchaseOrderID(res?.data?.data?.purchaseOrderId);
      } else {
        setAlertComponent({ open: true, type: "error", message: `No Data Found ` });
      }
    })
      .catch(function (error) {
        setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}` });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  }

  useEffect(() => {
    getProductsListing(requestPayload, filterText, filterFormData);
  }, [requestPayload]);

  const getProductsListing = (requestPayloadParam, filterTextParam, formData) => {
    setIsLoading(true);
    let param = `?page=${requestPayloadParam?.pageNumber}&pageSize=${requestPayloadParam?.pageSize}&search=${filterTextParam}`;
    if (requestPayloadParam.sortArray.length > 0) {
      param += `&sortBy=${requestPayloadParam.sortArray[0]}&sortOrder=${requestPayloadParam.sortArray[1]}`;
    }
    const filteredFormData = formData ? Object.entries(formData)
      .filter(([key, value]) => value !== '')
      .reduce((acc, [key, value]) => {
        acc[key] = value;
        return acc;
      }, {}) : {};
    if (filteredFormData && Object.keys(filteredFormData).length > 0) {
      Object.entries(filteredFormData).forEach(([key, value]) => {
        param += `&${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
      });
    }

    let promise = gateEntryServices.getGEProductList(id, param);
    promise.then((res) => {
      if (res.data.success === true) {
        setProductsListing(res?.data?.data);
      } else {
        setAlertComponent({ open: true, type: "error", message: `No Data Found ` });
      }
    })
      .catch(function (error) {
        setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}` });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };


  const onPaginationChange = (e, value) => {
    let requestPayloadInit = _.cloneDeep(requestPayload);
    requestPayloadInit.pageNumber = value;
    setRequestPayload(requestPayloadInit);
  }

  const onPageSizeChange = (e) => {
    let { value } = e.target;
    let requestPayloadInit = _.cloneDeep(requestPayload);
    requestPayloadInit.pageSize = value;
    requestPayloadInit.pageNumber = 1;
    setRequestPayload(requestPayloadInit);
  }

  const handleInputChange = (event) => {
    const value = event.target.value;
    if (value === '' || /^[0-9]+$/.test(value)) {
      setInputPage(value);
    }
  };

  const handleInputSubmit = (event) => {
    if (event.key === 'Enter') {
      const page = parseInt(inputPage, 10);
      if (!isNaN(page) && page > 0 && page <= productsListing?.totalPages) {
        onPaginationChange(event, page);
      } else {
        setInputPage(productsListing?.currentPage);
      }
    }
  };
  const [opendocumentattchementmodal, setOpenDocumentAttchementModal] = useState(false);

  const onSortChange = (index, sortBy, sortOrder) => {
    // let newSortLael = (sortOrder == "asc") ? "desc" : "asc";

    let requestPayloadInit = _.cloneDeep(requestPayload);
    let columnsInit = _.cloneDeep(columns);
    let newSortLael = (sortOrder == "asc") ? "desc" : "asc";
    requestPayloadInit.sortArray = [sortBy, newSortLael];
    requestPayloadInit.pageNumber = 1;

    for (let i = 0; i < columnsInit.length; i++) {
      columnsInit[i].sortLabel = "";
      if (i == index) {
        columnsInit[i].sortLabel = newSortLael;
      }
    }

    setRequestPayload(requestPayloadInit);
    setColumns(columnsInit);
  }

  const onFilterTextChange = (e) => {
    let { value } = e.target;
    setFilterText(value);
    debouncedSearch(value);
  };

  const onKeyPressHandler = (e) => {
    e.persist();
    if (e.key === "Enter") {
      onFilterSubmit();
    }
  };
  const onFilterSubmit = () => {
    getProductsListing(requestPayload, filterText);
  };

  const debouncedSearch = useCallback(
    _.debounce((searchTerm) => {
      let requestPayloadInit = _.cloneDeep(requestPayload);
      requestPayloadInit.pageNumber = 1;
      setRequestPayload(requestPayloadInit);

    }, 800),
    []
  );


  const download = Boolean(downloadEl);
  const handleClicks = (event) => {
    setdownloadEl(event.currentTarget);
  };
  const handleCloses = () => {
    setdownloadEl(null);
  };

  const openConfirmModal = (param) => {
    let obj = {};
    obj["id"] = param;
    if (param == "header") {
      obj["text"] = "Header Level Excel";
    }
    if (param == "line-item") {
      obj["text"] = "Line Item Level Excel";
    }
    if (param == "mdcc") {
      obj["text"] = "MDCC";
    }
    setConfirmObj(obj);
    setOpenPoPdfPurchaseModal(true);
  }

  const closeConfirmModal = (param) => {
    setConfirmObj({});
    setOpenPoPdfPurchaseModal(false);
  }

  const downloadPO = () => {
    setIsLoading(true);
    let bodyData = {
      // "gateEntryIds": [id],
      "type": confirmObj?.id, // "line-item", header, 
      "geNumber": geDetails?.geNumber
    };
    let fileName = "";
    

    // if (confirmObj?.id == "header") {
    //   fileName = `${geDetails?.geNumber}_HerderLevelExcel.xlsx`;
    // }
    // if (confirmObj?.id == "line-item") {
    //   fileName = `${geDetails?.geNumber}_LineItemExcel.xlsx`;
    // }
    // if (confirmObj?.id == "mdcc") {
    //   fileName = "MDCC_PDF.pdf";
    // } 
    const data = {
      url: `/v1/common/gate-entries/download`,
      bodyData: bodyData,
      method: "POST",
      fileName: fileName
    };
    downloadFile(data)
      .then(response => {
        if (isEmptyDash(response)) {
          setOpenPoPdfPurchaseSuccessModal(true);      
        } else {        
          setAlertComponent({ open: true, type: "success", message: `${response?.data?.message}` });          
        }
      })
      .catch(error => {
        setAlertComponent({ open: true, type: "error", message: `There is some error to download file. ` });
      })
      .finally(() => {
        setIsLoading(false);
        setOpenPoPdfPurchaseModal(false);
      })
  }
  const toggleDrawer = (newOpen) => () => {
    dispatch({ type: "TOGGLE_DRAWER", newOpen });
  };

  const handleTrackOrder = () => {
    setIsLoading(true);
    purchaseOrderServices.getPOTrackOrder(GRNPurchaseOrderID)
      .then(response => {
        if (response?.data?.success == true) {
          toggleDrawer(true)();
          setTrackOrderData(response?.data?.data);
        }
      })
      .catch(error => {
        setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}. ` });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const DrawerList = (
    <TrackOrder steps={trackOrderData} close={() => toggleDrawer(false)()} refresh={() => handleTrackOrder()} />
  );
  return (
    <>
      <div className="login-forms">
        <div className="text-centers">
          <div className="search_filter_outerse ms-auto">
            <div className="search_main">
              <h5>Gate Entry Detail</h5>
            </div>

            <div className="create_listing_project">
              {/* <button
                onClick={() => {
                  setOpenModifyGateEntry(true);
                }}
                className="gate_btn_lr_creationses"
              >
                Modify Gate Entry
              </button> */}
              {/* <button
                onClick={() => {
                  setOpenCancelGateEntry(true);
                }}
                className="btn btn-danger"
              >
                Cancel Gate Entry
              </button> */}
              {(secGEPermission?.TRACK_ORDER_GE?.read == true) && <div className="track_order_react_row">

                <button className="btn btn-outline-secondary" onClick={handleTrackOrder}>Track Order</button>

                <Drawer
                  anchor="right"
                  open={state.open}
                  onClose={toggleDrawer(false)}
                  style={{ zIndex: 99999 }}
                >
                  {DrawerList}
                </Drawer>
              </div>}
              {/* <button className="create_btn_lr_creations">Create GRN</button> */}
              <div>
              {(secGEPermission?.DOWNLOAD_GE?.read == true) && <Button
                  className="vendor_btn vendor_maine_contents"
                  id="basic-button"
                  aria-controls={download ? "basic-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={download ? "true" : undefined}
                  onClick={handleClicks}
                >
                  <FileDownloadIcon />
                  Download
                </Button>}
                <Menu
                  id="basic-menu"
                  anchorEl={downloadEl}
                  open={download}
                  onClose={handleCloses}
                  MenuListProps={{
                    "aria-labelledby": "basic-button",
                  }}
                >
                  <MenuItem onClick={() => openConfirmModal("header")}>
                    Header Level Excel
                  </MenuItem>
                  <MenuItem onClick={() => openConfirmModal("line-item")}>
                    Line Item Level Excel
                  </MenuItem>

                </Menu>
              </div>
              <Link to="/admin/vendor-Gate-Entry-Listing" style={{ textDecoration: "none" }}>
              <button className="btn btn-danger">Back</button>
              </Link>  
            </div>
          </div>

          <div className="lets_head_purchase_number_buyer_react_blocklist">
            <div className="first_podetail_basic_block_level_reacts">
              <div className="lets_react_order_listing_level_buyer">
                <div className="content_react_level_details">
                  <img src={podetailImage} alt="" />
                  <p className="lets_block_react_details_purchase">
                    Entry ID : {geDetails?.geNumber}
                  </p>
                </div>
                <div className="lets_pending_react_body">
                  Order Date :
                  <span className="date_solutions"> {strToDate(geDetails?.createdAt)} </span>
                  <div className="solution_asen_statsu_pending">
                    Status :<p className="date_solutions_status">{geDetails?.status}</p>
                  </div>
                </div>
              </div>
              <div className="lets_table_buyername_react_suntech">
                <table>
                  <tr>
                    <td className="name_asn_details_suntech_react_id">
                      Purchase Order No
                    </td>
                    <td>:</td>
                    <td className="project_bobt_name_tooltip_wraprow"><Tooltip title={geDetails?.poNumber}> {trimString(geDetails?.poNumber, 20)}</Tooltip>
                    </td>
                  </tr>
                  <tr>
                    <td className="name_asn_details_suntech_react_id">
                      Gate Entry Number
                    </td>
                    <td>:</td>
                    <td className="project_bobt_name_tooltip_wraprow"><Tooltip title={geDetails?.geNumber}> {trimString(geDetails?.geNumber, 20)}</Tooltip>
                    </td>
                  </tr>
                  <tr>
                    <td className="name_asn_details_suntech_react_id">
                      Gate Entry No. (SAP)
                    </td>
                    <td>:</td>
                    <td>
                    <Tooltip title={geDetails?.geNumberSap}> {trimString(geDetails?.geNumberSap, 20)}</Tooltip>
                    </td>
                  </tr>
                  <tr>
                    <td className="name_asn_details_suntech_react_id">
                      Received date
                    </td>
                    <td>:</td>
                    <td>{strToDate(geDetails?.receivedDate)}</td>
                  </tr>
                  <tr>
                    <td className="name_asn_details_suntech_react_id">
                      Lorry Receipt No
                    </td>
                    <td>:</td>
                    <td>{geDetails?.lrNumber}</td>
                  </tr>
                  <tr>
                    <td className="name_asn_details_suntech_react_id">
                      Lorry Receipt date
                    </td>
                    <td>:</td>
                    <td>{strToDate(geDetails?.lrDate)}</td>
                  </tr>
                  <tr>
                    <td className="name_asn_details_suntech_react_id">
                      Container No
                    </td>
                    <td>:</td>
                    <td>
                    <Tooltip title={geDetails?.containerNumber}> {trimString(geDetails?.containerNumber, 20)}</Tooltip>
                    </td>
                  </tr>
                  <tr>
                    <td className="name_asn_details_suntech_react_id">
                      Delivery Challan No
                    </td>
                    <td>:</td>
                    <td>
                    <Tooltip title={geDetails?.deliveryChallanNo}> {trimString(geDetails?.deliveryChallanNo, 20)}
                    </Tooltip>
                    </td>
                  </tr>
                  <tr>
                    <td className="name_asn_details_suntech_react_id">
                      Invoice No
                    </td>
                    <td>:</td>
                    <td>
                    <Tooltip title={geDetails?.invoice}> {trimString(geDetails?.invoice, 20)}
                    </Tooltip>
                    </td>
                  </tr>
                </table>
                <table>
                  <tr>
                    <td>Invoice date</td>
                    <td>:</td>
                    <td>{strToDate(geDetails?.invoiceDate)}</td>
                  </tr>
                  <tr>
                    <td>Total Invoice Amount</td>
                    <td>:</td>
                    <td>
                      {returnRateVal(geDetails?.totalInvoiceAmount)}
                      {/* ₹{totalInr(geDetails?.totalInvoiceAmount)} */}
                    </td>
                  </tr>
                  <tr>
                    <td>E -way bill No</td>
                    <td>:</td>
                    <td>
                    <Tooltip title={geDetails?.eWayBillNo}> {trimString(geDetails?.eWayBillNo, 20)}
                    </Tooltip>
                    </td>
                  </tr>
                  <tr>
                    <td>Security Inward date</td>
                    <td>:</td>
                    <td>{strToDate(geDetails?.securityInwardDate)}</td>
                  </tr>
                  <tr>
                    <td>Vendor Code</td>
                    <td>:</td>
                    <td>
                    <Tooltip title={geDetails?.vendorCode}> {trimString(geDetails?.vendorCode, 20)}
                    </Tooltip>
                    </td>
                  </tr>
                  <tr>
                    <td>Vendor Name</td>
                    <td>:</td>
                    <td className="project_bobt_name_tooltip_wraprow">
                      <Tooltip title={geDetails?.vendorName}> {trimString(geDetails?.vendorName, 20)}</Tooltip>
                    </td>
                  </tr>
                  <tr>
                    <td>Plant</td>
                    <td>:</td>
                    <td>
                    <Tooltip title={geDetails?.plant}> {trimString(geDetails?.plant, 20)}
                    </Tooltip>
                    </td>
                  </tr>
                  <tr>
                    <td>Delivery Challan No</td>
                    <td>:</td>
                    <td>
                    <Tooltip title={geDetails?.deliveryChallanNo}> {trimString(geDetails?.deliveryChallanNo, 20)}</Tooltip>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
          <div className="search_filter_outers_react ms-auto">
            <div className="search_main">
              <div id="custom-search-input">
                <div className="input-group col-md-12">
                  <input
                    type="text"
                    className="form-control input-lg"
                    placeholder="Search here"
                    fdprocessedid="8achb"

                    onChange={onFilterTextChange}
                    value={filterText}
                    onKeyPress={onKeyPressHandler}
                  />
                  <span className="input-group-btn">
                    <button
                      className="btn btn-info btn-lg"
                      type="button"
                      fdprocessedid="trsp06"
                    >
                      <span className="glyphicon glyphicon-search">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-search"
                          viewBox="0 0 16 16"
                        >
                          <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"></path>
                        </svg>
                      </span>
                    </button>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="listing_main listing_main_dragdropcontext_body" style={{ overflowX: "scroll" }}>
          <table className="dragdropcontext_ondragend_block_arrow">
          <thead style={{ position: "sticky", top: "0", zIndex: 1 }}>
                <tr>
                  <th className="vendor_tabels">
                    {/* <input type="checkbox" /> */}
                  </th>
                  {columns.map((column, index) => (<>
                    <th className="vendor_tabels ">
                      <div className="PoDetailTableHeading">
                        <div className="d-flex">
                          <p>{column?.label}</p>
                          {(column.isSort == true) && <span onClick={(e) => onSortChange(index, column.id, column.sortLabel)} className="table-sort-ico">
                            {(column.sortLabel != "asc") && <img src={topArrow} />}
                            {(column.sortLabel == "asc") && <img src={topHighlightArrow} />}
                            {(column.sortLabel != "desc") && <img src={bottomArrow} />}
                            {(column.sortLabel == "desc") && <img src={bottomHighlightArrow} />}
                          </span>}
                        </div>
                      </div>
                    </th>
                  </>))}
                </tr>
              </thead>
              <tbody style={{ overflowY: "scroll", width: "200px" }}>
                {productsListing?.products.length < 1 && <>
                  <tr>
                    <td colSpan={5} className="text-center list-no-data">No Data Found</td>
                  </tr>
                </>}
                {productsListing?.products?.map((row, rowIndex) => (
                  <tr key={rowIndex} className="maine_tr_vendor">
                    <td>
                      <input type="checkbox" />
                    </td>
                    {columns.map((column, index) => (<>
                      {(column?.formate == "RATE") ?
                        <td> 
                        {returnRateVal(row[column?.id])}
                        {/* ₹{totalInr(returnZero(row[column?.id]))}  */}
                      </td> :
                      <td key={index} >
                        <Tooltip title={row[column.id] || "N/A"}>
                        {trimString(row[column.id], 12 || "N/A")}
                      </Tooltip>
                      </td>}

                    </>
                    ))}

                  </tr>
                ))}
                {/* <tr className="maine_tr_vendor">
                  <td>
                    <input type="checkbox" />
                  </td>
                  <td>10002345</td>
                  <td>Mild Steel Rod 12mm</td>
                  <td>500</td>
                  <td>KG</td>
                  <td>WH01</td>
                  <td>₹ 35,600</td>
                  <td>450</td>
                  <td>500</td>
                  <td>50</td>
                  <td>Partial Delivery</td>
                </tr> */}
              </tbody>
            </table>
          </div>
          <div className="lets_pagination_package_listing_react">
            <div className="pagination_select_react_packagelr_detail">
              <select
                className="form-select packagelrlisting from-hs"
                onChange={onPageSizeChange}
                value={requestPayload?.pageSize}
              >
                <option selected="10">10</option>
                <option value="15">15</option>
                <option value="20">20</option>
                <option value="25">25</option>
                <option value="50">50</option>
              </select>
              <span className="react_text_showing">
                {` Showing rows ${Number(productsListing?.pageSize) * Number(productsListing?.currentPage - 1) + 1} to ${Number(productsListing?.pageSize) * Number(productsListing?.currentPage - 1) + Number(productsListing?.products?.length)} of ${productsListing?.totalItems}`}
              </span>
            </div>
            <Stack spacing={2}>
              <Pagination
                count={productsListing?.totalPages}
                page={productsListing?.currentPage}
                onChange={(event, page) => {
                  setInputPage(page);
                  onPaginationChange(event, page);
                }}
                renderItem={(item) => {
                  if (item.page === productsListing?.currentPage) {
                    return (
                      <input
                        className="form-control listing_currentpagination"
                        type="text"
                        value={inputPage}
                        onChange={handleInputChange}
                        onKeyDown={handleInputSubmit}
                       
                      />
                    );
                  }
                  return (
                    <PaginationItem
                      className="pagination_react_listings"
                      slots={{ previous: ArrowBackIcon, next: ArrowForwardIcon }}
                      {...item}
                    />
                  );
                }}

              // count={5}
              // renderItem={(item) => (
              //   <PaginationItem
              //     className="pagination_react_listings"
              //     slots={{ previous: ArrowBackIcon, next: ArrowForwardIcon }}
              //     {...item}
              //   />
              // )}
              />
            </Stack>
          </div>

          {/* Header Level Excel Purchase listing */}

          <Modal
            open={openpopdfpurchasemodal}
            onClose={closeConfirmModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenPoPdfPurchaseModal(false)}
                ></button>
              </div>
              <div class="modal-bodys">
                <p class="project_Manager_bidding">
                  Are you sure you want to download
                  <br /> {confirmObj?.text}
                </p>
                <div className="all_btn_modal_listing">
                  <button
                    href="onboarding_status.html"
                    className="view_progresse"
                    onClick={downloadPO}
                  >
                    Yes
                  </button>

                  <button
                    href="onboarding_status.html"
                    className="view_lsting"
                    onClick={closeConfirmModal}
                  >
                    No
                  </button>
                </div>
              </div>
            </Box>
          </Modal>
          {/* Header Level Sucessfully Purchase listing */}
          <Modal
            open={openpopdfpurchasesuccessmodal}
            onClose={() => setOpenPoPdfPurchaseSuccessModal(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenPoPdfPurchaseSuccessModal(false)}
                ></button>
              </div>
              <div class="modal-bodys">
                <img src={checkImage} alt="" />
                <p class="project_manager_bidding">
                  Selected <b>{confirmObj?.text}</b> has been
                  <br /> successful download
                </p>
                <div className="all_btn_modal_listing">
                  <button
                    href="onboarding_status.html"
                    className="view_progresse"
                    onClick={() => {
                      setOpenPoPdfPurchaseSuccessModal(false);
                    }}
                  >
                    Ok
                  </button>
                </div>
              </div>
            </Box>
          </Modal>

          {/* Modify Gate Entry Modal */}
          {/* <Modal
            open={openmodifygateentry}
            onClose={() => setOpenModifyGateEntry(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenModifyGateEntry(false)}
                ></button>
              </div>
              <div class="modal-bodys">
                <p class="project_manager_bidding">
                  Are you sure you want to "<b>Modify Gate Entry</b>"
                  <br />
                </p>
                <div className="all_btn_modal_listing">
                  <button
                    href="onboarding_status.html"
                    className="view_progresse"
                    onClick={() => {
                      setOpenModifyGateEntry(false);
                    }}
                  >
                    Yes
                  </button>

                  <button
                    href="onboarding_status.html"
                    className="view_lsting"
                    onClick={() => setOpenModifyGateEntry(false)}
                  >
                    No
                  </button>
                </div>
              </div>
            </Box>
          </Modal> */}
          {/* Cancel Gate Entry Modal */}
          {/* <Modal
            open={opencancelgateentry}
            onClose={() => setOpenCancelGateEntry(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenCancelGateEntry(false)}
                ></button>
              </div>
              <div class="modal-bodys">
                <p class="project_manager_bidding">
                  Are you sure you want to "<b>Cancel Gate Entry</b>"
                  <br />
                </p>
                <div className="all_btn_modal_listing">
                  <button
                    href="onboarding_status.html"
                    className="view_progresse"
                    onClick={() => {
                      setOpenCancelGateEntry(false);
                    }}
                  >
                    Yes
                  </button>

                  <button
                    href="onboarding_status.html"
                    className="view_lsting"
                    onClick={() => setOpenCancelGateEntry(false)}
                  >
                    No
                  </button>
                </div>
              </div>
            </Box>
          </Modal> */}
        </div>
        
        <SupportChat
          vendorDetails={{ vendor: { _id: geDetails?.vendorId } }}
          isP2P={true}
          P2PData={{
            isActive: true,
            vendorName: geDetails?.vendorName,
            refType: "GE",
            referenceId: geDetails?._id,
          }}
        />

        <AlertComponent
          alertComponent={alertComponent}
          handleClose={handleCloseAlert}
        />

        <Backdrop
          sx={{
            color: "#fff",
            zIndex: (theme) => 99999999,
          }}
          open={isLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>

      </div>
    </>
  );
}

export default GateEntryDetail;
